import { rootMargin } from '@helpers/animate';
import { equalDates, formatDate, formatDateISO } from '@helpers/date';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import SvgClipPath from '@img/inner-hero-clip-path.svg';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import S from './EventPageHeroBanner.styles';
import { linkAria } from '@helpers/utils';
const EventPageHeroBanner = (props) => {
    const [ref, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    if (!props.title && !props.content) {
        return null;
    }
    const srcs = props.image ? getSrcs(props.image, 730, 360, 7, 960 / 500) : [];
    const sizes = `${until(Device.TabletLarge)} 100vw, ${until(Device.DesktopSmall)} 33vw, ${until(Device.ActualDesktop)} 50vw, 960px)`;
    return (React.createElement(S.Container, { id: props.anchorId, ref: ref, "data-animate": inView, "data-layout-variant": props.variant ?? 'detail' },
        React.createElement(S.TagArea, null,
            React.createElement(S.Tag, null, props.tag ?? 'LCCI Event')),
        React.createElement(S.Inner, { spacing: "none", "data-layout": 'default' },
            React.createElement(S.ContentWrapper, null,
                !props.endDate || equalDates(props.date, props.endDate) ? (React.createElement(S.Info, null,
                    getEventType(),
                    " Event |",
                    ' ',
                    React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date, 'EEEE do LLLL yyyy')))) : (React.createElement(S.Info, null,
                    getEventType(),
                    " Event |",
                    ' ',
                    React.createElement(S.Date, { dateTime: formatDateISO(props.date) },
                        formatDate(props.date, 'EEEE do LLLL yyyy'),
                        ' ',
                        "-",
                        ' '),
                    React.createElement(S.Date, { dateTime: formatDateISO(props.endDate) }, formatDate(props.endDate, 'EEEE do LLLL yyyy')))),
                React.createElement(S.Title, null, props.title),
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
                props.loggedIn ? (React.createElement(S.ButtonWrapper, null,
                    props.ctaBook && (React.createElement(LinkButton, { buttonType: "orange-solid", "aria-label": linkAria(props.ctaBook.text ?? '', props.ctaBook.target, props.translations && props.translations['lcci.link.newtab']), href: props.ctaBook.url, target: props.ctaBook.target, icon: props.ctaBook.icon }, props.ctaBook.text)),
                    props.fullyBooked && (React.createElement(S.CapacityLabel, null, props.capcityLabel ?? 'Fully Booked')))) : (React.createElement(S.ButtonWrapper, null, props.ctaLoggin && (React.createElement(LinkButton, { buttonType: "blue-solid", "aria-label": linkAria(props.ctaLoggin.text ?? '', props.ctaLoggin.target, props.translations && props.translations['lcci.link.newtab']), href: props.ctaLoggin.url, target: props.ctaLoggin.target, icon: props.ctaLoggin.icon }, props.ctaLoggin.text))))),
            props.image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.ImageInner, null,
                    React.createElement(S.Img, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText, loading: "eager" })),
                React.createElement(SvgClipPath, null))))));
    function getEventType() {
        switch (props.eventLocation) {
            case 'in-person':
                return 'In person';
            case 'online':
                return 'Online';
            case 'training':
                return 'Training';
            case 'webinar':
                return 'Webinar';
            case 'hybrid':
                return 'Hybrid';
            default:
                return undefined;
        }
    }
};
export default EventPageHeroBanner;
